import { render } from "./SideBar.vue?vue&type=template&id=53c8618c&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=ts"
export * from "./SideBar.vue?vue&type=script&lang=ts"

import "./SideBar.vue?vue&type=style&index=0&id=53c8618c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-53c8618c"

export default script